import type { MarketPositionHistory } from '@/lib/procedures/marketPositionHistory.contract'

export type Mode = 'collateralUsd' | 'borrowAssetsUsd'

const AMOUNT_FIELD = {
  collateralUsd: 'collateralAssets',
  borrowAssetsUsd: 'borrowAssets'
} as const satisfies Record<Mode, keyof MarketPositionHistory['points'][number]>

/**
 * The card's `{ x, y }` series for one mode. `unpriced` is true when the position has nonzero
 * amounts but none of them has a USD value (a failed price read), which the card shows as an error
 * rather than as $0.
 */
export function toHoverCardSeries(history: MarketPositionHistory | undefined, mode: Mode) {
  const points = history?.points ?? []
  const series = points.map(point => ({ x: point.timestamp, y: point[mode] }))
  const held = points.filter(point => {
    const amount = point[AMOUNT_FIELD[mode]]
    return amount !== null && BigInt(amount) !== 0n
  })
  const unpriced = held.length > 0 && held.every(point => point[mode] === null)
  return { series, unpriced, partial: history?.partial ?? false }
}
